<script setup>
import { ref, watch } from 'vue'
import { defineProps, useTemplateRef, defineEmits, getCurrentInstance } from 'vue'
import { useRoute } from 'vue-router'
import { getapifielddatalist, getopenreportformlist } from '@/port/clientSide/workbench'
import { getuserfielddatalist } from '@/port/clientSide/applicationRouting'
import { isJSON } from "@/api/utils";
import { filesConfig, filePreview } from '@/api/global'
import { cloneDeep } from 'lodash'
import { ElMessage } from 'element-plus'
import { exportExcel } from './excelExport'

import richTextEdit from '@/components/common/richTextEditDia.vue' // 富文本编辑
import detailReadonly from '@/components/common/detailReadonly.vue' // 详情只读

const props = defineProps({
  config: {
    type: Object,
    default: () => ({})
  }
})

// 获取this
const currentInstance = getCurrentInstance()
const route = useRoute()

const spaceid = route.query.spaceid
const upaceid = route.query.upaceid

const emit = defineEmits(['cancle', 'toDetail', 'filePreview'])

const tableBodyRef = useTemplateRef('tableBodyRef')
const detailReadonlyRef = useTemplateRef('detailReadonlyRef')
const richTextEditRef = useTemplateRef('richTextEditRef')

const tempRichAndDetailsName = ref('')
const approvalInfo = ref({})
const appList = ref([])

const cancle = () => {
  emit('cancle')
} 

const preview = () => {
  emit('filePreview')
}

const toDetail = () => {
  emit('toDetail', props.config)
}

const init = () => {
  if (props.config.type === 'dataGenerate' && props.config.data.display === 'detail') {
    for (const ele of props.config.data.portInfo) {
      getDetailList(ele)
    }
  }
}

const getRelationUser = (list) => {
  if (!list) return
  return list.map(item=>item.realname || item.name).join(',')
}

const getCheckbox = (list) => {
  return list.join(',')
}

const getDetailList = async (ele) => {
  const _power = {
    approvalId: ele.approvalId,
    curpage: 0,
    pagesize: 0
  }
  if (spaceid) {
    _power.spaceid = spaceid
  }
  if (upaceid) {
    _power.upaceid = upaceid
  }
  const { data, code } = await getopenreportformlist(_power)
  if (code === 0) {
    let power = {}
    if (ele.iId === 1 || ele.iId === 5) {
      power = data.find(item=>item.userId)
    } else {
      power = data.find(item=>!item.userId)
    }
    const param = {
      type: 0,
      curpage: 1,
      pagesize: 1,
      cateId: -1,
      key: '',
      querys: {},
      query: ele.query || {},
      approvalId: ele.approvalId,
      reportFormId: power.reportFormId
    }
    let portObj = {
      1: getuserfielddatalist,
      7: getapifielddatalist,
      5: getuserfielddatalist
    }
    const port = portObj[ele.iId]
    if (!port) return
    if (ele.iId === 5) {
      param.selfuser = 0
    }
    const res = await port(param)
    if (res.code === 0) {
      const resData = {
        scope: res.data[0] || {},
        appName: ele.appName,
        approvalId: ele.approvalId,
        reportFormId: power.reportFormId,
        iId: ele.iId,
        property: ele.property,
        approval: ele.approval
      }
      appList.value.push(resData)
    }
  }
}


const strImgAndFileData = (val) => {
  if (!val) return ''
  let filename = ''
  if (typeof val === 'object') {
    filename = val.realname || val.response || ''
  } else {
    filename = val
  }
  if (!filename) return ''
  try {
    const mps = filename.split('/')
    const mp = mps[mps.length - 1]
    const li = mp.split('-')
    let str = ''
    if (li.length > 2) {
      li.shift()
      str = li.join('-')
    } else {
      str = mp.split('-')[1]
    }
    return str || filename
  } catch (err) {
    return filename
  }
}

const goPreview = (val, down, isEdit) => {
  filePreview(val, down, isEdit)
}

const openRichAndDetails = async (scope, filed, app) => {
  if (filed.type === 'details') {
    const value = cloneDeep(scope[filed.title])
    const control = filed
    const formdata = typeof value === 'string' ? JSON.parse(value) : value
    formdata.pop()
    const fileControl = control.list.find(f=> f.type === 'file')
    if (fileControl) {
      for (const ele of formdata) {
        const file = ele[`${fileControl.title}_${fileControl.type}`]
        if (file && file.length > 0) {
          let newFiled = file.map(f=>{
            let name = f.response ? f.response.split('/')[f.response.split('/').length - 1] : ''
            name = name.split('-')[name.split('-').length - 1]
            return {
              ...f,
              url: currentInstance.proxy.$imgurl + f.response,
              name
            }
          })
          ele[`${fileControl.title}_${fileControl.type}`] = newFiled
        }
      }
    }
    // 将明细控件改为只读
    control.per = 2
    control.list.forEach(item=> {
      item.per = 2
    })
    if (filed.filedInfo && filed.filedInfo.detailed && filed.filedInfo.detailed.fieldAppen && filed.filedInfo.detailed.fieldAppen.length > 0) {
      control.list = control.list.filter(f=> filed.filedInfo.detailed.fieldAppen.includes(`${f.title}_${f.type}`))
    }
    detailReadonlyRef.value.open({
      formdata,
      control,
    }, 'details')
  } else {
    const bindinf = scope[filed.title]
    tempRichAndDetailsName.value = app.appName
    approvalInfo.value = app.approval || {}
    richTextEditRef.value.open({ bindinf })
  }
}

const downTableContent = (idx) => {
  const app = appList.value[idx]
  const list = []
  const scope = app.scope
  const obj = {}
  for (const ele of app.property) {
    obj[ele.name] = ''
    if (ele.type === 'image') {
      obj[ele.name] = isJSON(scope[ele.title]).map(item=>item.response).join(',')
    } else if (ele.type === 'file') {
      obj[ele.name] = isJSON(scope[ele.title]).map(file=>strImgAndFileData(file)).join(',')
    } else if (ele.type === 'relation-user') {
      obj[ele.name] = getRelationUser(scope[ele.title])
    } else if (ele.type === 'checkbox') {
      obj[ele.name] = getCheckbox(scope[ele.title])
    } else {
      obj[ele.name] = scope[ele.title]
    }
  }
  list.push(obj)
  exportExcel(list, app.appName)
}

// 复制表格内容函数
const copyTableContent = async (idx) => {
  if (!tableBodyRef.value) return
  
  // 获取所有行（detail-body-col）
  const rows = tableBodyRef.value[idx].querySelectorAll('.detail-body-col')
  
  if (rows.length === 0) {
    console.warn('没有找到表格内容')
    return
  }
  
  // 构建文本内容
  let textContent = ''
  
  // 添加表头
  textContent += '序号\t名称\t内容\n'
  
  // 遍历每一行
  rows.forEach(row => {
    // 获取序号
    const numCell = row.querySelector('.cell-num')
    const num = numCell ? numCell.textContent.trim() : ''
    
    // 获取名称
    const nameCell = row.querySelector('.cell-name')
    const name = nameCell ? nameCell.textContent.trim() : ''
    
    // 获取内容
    const contentCell = row.querySelector('.cell-content')
    let content = ''
    if (contentCell) {
      // 获取纯文本内容，排除可能的图标或按钮
      content = contentCell.textContent.trim()
    }
    
    // 用制表符连接各列
    textContent += `${num}\t${name}\t${content}\n`
  })
  
  // 复制到剪贴板
  try {
    await navigator.clipboard.writeText(textContent)
    // 可以添加成功提示
    // 如果需要提示用户
    ElMessage.success('复制成功')
  } catch (err) {
    console.error('复制失败:', err)
    // 降级方案
    fallbackCopy(textContent)
  }
}

// 降级复制方案（兼容旧浏览器）
const fallbackCopy = (text) => {
  const textarea = document.createElement('textarea')
  textarea.value = text
  textarea.style.position = 'fixed'
  textarea.style.opacity = '0'
  document.body.appendChild(textarea)
  textarea.select()
  
  try {
    document.execCommand('copy')
    console.log('降级复制成功')
  } catch (err) {
    console.error('降级复制失败:', err)
  } finally {
    document.body.removeChild(textarea)
  }
}

watch(()=> props.config, (newVal) => {
  if (newVal.data) {
    init()
  }
})

</script> 

<template>
  <div class="data-generate">
    <template v-if="config.loading">
      <div class="data-generate-loading">
        <div class="answer-content">
          <!-- 内容创作不要显示这个 -->
          <div class="text" v-show="config.type !== 'contentGenerate'">{{ config.content }}</div>
          <img class="img" src="https://bigdata.topeti.com/mainPlatform/search.gif" alt="">
        </div>
      </div>
      <div class="data-generate-btn" @click="cancle">进行中/取消任务</div>
    </template>
    <template v-else>
      <template v-if="config.type === 'fileGenerate' || config.type === 'contentGenerate'">
        <template v-if="config.data">
          <div class="file-generate-tips" v-if="config.type === 'contentGenerate'">根据您的需求，为您生成一份题目为:<span>{{ config.name }}</span>的ai文档</div>
          <div class="file-generate-tips" v-else>这是你需要的文件：<span>{{ config.name }}</span></div>
          <div class="file-card-container" >
            <!-- 中间文本区域 -->
            <div class="text-wrapper">
              <el-icon class="file-icon"><Document /></el-icon>
              <div class="file-name">{{ config.name }}</div>
              <div class="action-link" @click="preview">点击查看</div>
            </div>

            <!-- 右侧占位（设计稿中的卡片预览缩略图位置） -->
            <div class="thumbnail-placeholder">
              <img src="https://bigdata.topeti.com/PCRepository/mainPlatform/fileGenerateIcon.png" alt="">
            </div>
          </div>
        </template>
        <template v-else>
          <div class="file-generate-tips">{{config.type === 'contentGenerate' ? '生成文档失败，请重新生成。' : '未找到文件'}}</div>
        </template>
      </template>
      <template v-else>
      <template v-if="config.data.display === 'detail'">
        <div class="data-generate-text">{{ config.content }}</div>
        <template v-for="(app, appIdx) in appList" :key="app">
          <div class="data-generate-detail">
            <div class="detail-header">
              <span>{{ app.appName }}</span>
              <span>
                <i class="iconfont icon-fuzhi" @click="copyTableContent(appIdx)"></i>
                <i class="iconfont icon-xiazai" @click="downTableContent(appIdx)"></i>
              </span>
            </div>
            <div class="detail-body" ref="tableBodyRef">
              <template v-if="Object.keys(app.scope).length === 0">
                <!-- 暂无数据 -->
                  <div class="no-data">
                  暂无数据
                  </div>
              </template>
              <template v-else>
                <div v-for="(item, idx) in app.property" class="detail-body-col" :key="item.title">
                  <div class="detail-body-cell cell-num">
                    {{ idx + 1 }}
                  </div>
                  <div class="detail-body-cell" style="justify-content: center;">
                    <div class="cell-name">
                      {{ item.name }}
                    </div>
                  </div>
                  <div class="detail-body-cell cell-content">
                    <template v-if="item.type === 'image'">
                      <!-- 图片 -->
                      <template v-for="(img, imgIdx) in isJSON(app.scope[item.title])" :key="imgIdx">
                        <el-image class="cell-content-img" style="width: 40px;height: 40px;" preview-teleported :src="img.url ? img.url : $imgurl + img.response + '?accesstoken=' + filesConfig()" :preview-src-list="[img.url ? img.url : $imgurl + img.response + '?accesstoken=' + filesConfig()]"  fit="cover" />
                      </template>
                    </template>
                    <template v-else-if="item.type === 'file'">
                      <!-- 文件 -->
                        <template v-for="(file, fileIdx) in isJSON(app.scope[item.title])" :key="fileIdx">
                        <span @click.stop="goPreview(file, false)" type="primary" style="width: fit-content;" class="img-file-content">
                          {{ strImgAndFileData(file) }}
                        </span>
                      </template>
                    </template>
                    <template v-else-if="['details', 'richTextWid'].includes(item.type)">
                      <!-- 明细控件 -->
                      <div class="cell-details"  @click.stop="openRichAndDetails(app.scope, item, app)">
                        <i class="iconfont icon-shujuchaxun"></i>
                        请点击查看
                      </div>
                    </template>
                    <template v-else-if="item.type === 'relation-user'">
                      {{ getRelationUser(app.scope[item.title]) }}
                    </template>
                    <template v-else-if="item.type === 'checkbox'">
                      {{ getCheckbox(app.scope[item.title]) }}
                    </template>
                    <template v-else>
                      {{ app.scope[item.title] }}
                    </template>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>
        </template>
        <template v-else-if="config.data.display === 'list'">
          <div class="data-generate-list">
            <div class="data-generate-list-title">
              <span class="list-detail">已为您找到</span>
              <span class="list-detail count">{{ config.data.portInfo.length }}</span>
              <span class="list-detail">张表，请点击查看</span>
            </div>
            <div class="data-generate-list-btn" @click="toDetail">
              <img class="img" src="https://bigdata.topeti.com/mainPlatform/detailImg.png" alt="">
              <span>点击查看</span>
            </div>
          </div>
        </template>
      </template>
    </template>
    <detailReadonly ref="detailReadonlyRef" />
    <richTextEdit :richTitle="tempRichAndDetailsName" :isReadonly="true" :width="`${approvalInfo.pdwidth || 60}%`" :isAppendRightTools="false" ref="richTextEditRef" />
  </div>
</template>

<style scoped lang='scss'>
.data-generate {
  padding-left: 10px;
  &-text {
    color: #000000;
    font-weight: 400;
    font-size: 16px;
    height: 40px;
    line-height: 40px;
  }
  &-loading {
    .answer-content {
      height: 40px;
      display: flex;
      align-items: center;
      .text {
        color: #000000;
        font-weight: 400;
        font-size: 16px;
      }
      .img {
        width: 40px;
        height: 40px;
        margin-left: 5px;
      }
    }
  }
  &-btn {
    width: 160px;
    height: 40px;
    border-radius: 27px;
    background-color: #FFFFFF;
    border: 1px solid #F0F2F6;
    box-shadow: 0px 0px 16px 0px rgba(69, 80, 220, 0.1);
    color: #4081FF;
    font-weight: 400;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-top: 10px;
  }
  &-list {
    width: 300px;
    height: 112px;
    border-radius: 8px;
    background-color: #F1F6FE;
    border: 1px solid #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    &-btn {
      margin-top: 16px;
      width: 280px;
      height: 40px;
      border-radius: 27px;
      background-color: #FFFFFF;
      border: 1px solid #F0F2F6;
      box-shadow: 0px 0px 16px 0px rgba(69, 80, 220, 0.1);
      color: #4081FF;
      font-weight: 400;
      cursor: pointer;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      .img {
        width: 34px;
        height: 34px;
      }
    }
    &-title {
      color: #000000;
      font-weight: 400;
      font-size: 16px;
      .count {
        color: #4550DC;
        margin: 0 3px;
      }
    }
  }
  &-detail {
    width: 1084px;
    margin-bottom: 20px;
    border-radius: 12px;
    overflow: hidden;
    .detail-header {
      background-color: #F0F2FF;
      height: 40px;
      padding: 0 20px;
      border: solid 1px transparent;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .icon-fuzhi {
        color: #81839A;
        font-size: 16px;
        cursor: pointer;
      }
      .icon-xiazai {
        color: #81839A;
        font-size: 16px;
        cursor: pointer;
        margin-left: 10px;
      }
    }
    .detail-body {
      border: solid 1px #E4E7F7;
      background-color: #fff;
      &-col {
        width: 100%;
        display: flex;
        border-bottom: 1px solid #E4E7F7;
        box-sizing: border-box;
        &:last-child {
          border-bottom: none;
        }
      }
      .no-data {
        min-height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &-cell {
        min-height: 40px;
        border-right: 1px solid #E4E7F7;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        color: #000000;
        font-weight: 400;
        font-size: 14px;
        .cell-details {
          color: #3B82F6;
          cursor: pointer;
        }
        &:last-child {
          border-right: none;
        }
      }
      .cell-num {
        width: 60px;
        justify-content: center;
      }
      .cell-name {
        width: 80px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        padding: 0 5px;
        text-align: center;
      }
      .cell-content {
        padding: 5px 20px;
        flex: 1;
        &-img {
          margin-left: 10px;
          width: 40px;
          height: 40px;
          cursor: pointer;
          &:first-child {
            margin-left: 0;
          }
        }
      }
    }
  }
}

.img-file-content {
  cursor: pointer;
  padding-right: 5px;
  color: #4081FF;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;

  // flex: 1;
  &:hover {
    text-decoration: underline;
  }
}

.file-generate-tips {
  font-size: 14px;
  font-weight: 500;
  span {
    color: #4081FF;
  }
}
.file-card-container {
  margin-top: 15px;
  /* 基础定位与尺寸 */
  width: 384px;
  height: 116px;

  /* 边框与圆角 */
  border-radius: 12px;
  border: 1px solid #EEEEEE;
  
  /* 背景与阴影 - 精确匹配 rgba(0, 0, 0, 0.05) */
  background-color: #FFFFFF;
  box-shadow: 0px 4px 7.4px 0px rgba(0, 0, 0, 0.05);

  /* Flex 布局处理内部排列 */
  display: flex;
  align-items: center;
  padding: 0 0 0 20px; /* 左右留白 */
  box-sizing: border-box;
  /* 中间文字区域 */
  .text-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-grow: 1; /* 占据剩余空间 */
  }

  .file-icon {
    color: #4081FF;
    font-size: 18px;
  }
  .file-name {
    font-size: 14px;
    font-weight: 500;
    color: #333333;
    width: 220px;
    margin: 8px 0;
    overflow: hidden;      /* 隐藏溢出内容 */
    -webkit-line-clamp: 2; /* 限制为2行 */
    text-overflow: ellipsis; /* 显示省略号 */
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .action-link {
    font-size: 14px;
    color: #2E7AFF; /* 典型的链接蓝色，可根据实际微调 */
    cursor: pointer;
  }

  /* 右侧占位符：模拟设计稿右侧那个带有线条的灰色卡片图形 */
  .thumbnail-placeholder {
    width: 140px;
    height: 80px;
    border-radius: 4px;
    margin-left: 20px;
    position: relative;
    img {
      width: 100%;
    }
  }
}

</style>
